<template>
  <div class="inline-block relative border-2 border-solid border-gray-500 rounded-full p-2">
		<input type="radio" name="toggle" value="false" class="absolute cursor-pointer opacity-0 z-20" @change="toggle('disable')"/>
		<label class="inline-block text-gray-800 text-center z-10">X</label>
		<input checked type="radio" name="toggle" value="-1" class="absolute cursor-pointer opacity-0 z-20" @change="toggle('off')" />
		<label class="inline-block text-gray-800 text-center z-10">-</label>
		<input type="radio" name="toggle" value="true" class="absolute cursor-pointer opacity-0 z-20" @change="toggle('on')" />
		<label class="inline-block z-10">
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M5 13L9 17L19 7" stroke="#4A5568" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	</label>
	<span class="h-4 w-4 absolute top-0.5 left-3" :class="[ toggleStatus === 'on' ? 'bg-red-500 left-6 transform translate-x-full' : 'bg-green-500 left-4' ]"></span>
  </div>
</template>

<script>
export default {
  props: {
    status: Boolean
  },
  model: {
    prop: 'status',
    event: 'toggle'
  },
  data () {
    return {
      disabled: false,
      toggleStatus: this.status
    }
  },
  methods: {
		toggle (value) {
			console.log('toggle')
			if (value === 'on') {
				this.disabled = false
				this.toggleStatus = true
			} else if (value === 'off') {
				this.disabled = false
				this.toggleStatus = false
			} else {
				this.disabled = true
			}
		}
	}
}
</script>
